import { render, staticRenderFns } from "./Websites.vue?vue&type=template&id=4e21c79a&"
import script from "../websites.js?vue&type=script&lang=js&"
export * from "../websites.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports